module.exports = __webpack_public_path__ + "img/table_order_asc.2a683331.svg";